import template from './region-list.html';
import controller from './region-list.controller';

let regionListComponent = {
  bindings: {},
  template,
  controller
};

export default regionListComponent;



// WEBPACK FOOTER //
// ./client/app/components/region/region-list.component.js